// 消息推送
export default {
    createTime: '创建时间',
    startTime: '开始日期',
    endTime: '结束日期',
    to: '至',
    title: '标题',
    titleSeach: '标题查询',
    founder: '创建人',
    pushModel: '推送模式',
    pushTime: '推送时间',
    receiver: '接收人',
    priority: '优先级',
    messageContent: '消息内容',
    operate: '操作',
    detail:'详情',
    all:'全部',
    newMessagePush:' 新建消息推送',
    messagePushDetails:' 消息推送详情',
    urgent: '紧急',
    high: '高',
    middle: '中',
    low: '低',
    single: '单次',
    timing: '定时',
    cycle: '循环',
    sendTime: '发送时间',
    interval: '间隔',
    pleaseEnter: '请输入',
    plEnterTitle: '请输入标题',
    minute: '分钟',
    names: '名称',
    mobilePhone: '手机',
    plenterMessageCount: '请输入消息内容',
    selectPriority: '请选择优先级',
    selectPushModel: '请选择推送模式',
    selectTime: '请选择时间',
    selectInterval: '请选择间隔',
    selectReceiver: '请选择接收人',
    delOperate: '消息被删除后，将无法恢复，请请谨慎操作！',
    select: '请选择',
    nameSeach: '姓名查询',
    addDepartment: '添加部门',
    department: '部门',
    license: '执照',
    name: '姓名',
    liceseType: '执照类型',
    personal: '个人',
    resetDepart: '此部门已存在！请重新选择部门',
    selectHasuserdepart: '请选择有用户的部门',
}
